import type { ButtonHTMLAttributes } from "react";

// The two button shapes the dialogs already paint. Classes stay literal so a
// call site that switches over keeps the same size, colour, and disabled fade.
const VARIANT = {
  primary:
    "flex items-center justify-center gap-1.5 rounded bg-accent px-3 py-1.5 text-xs font-medium text-canvas hover:bg-accent-hover disabled:opacity-50",
  quiet: "rounded p-1 hover:bg-hover",
} as const;

export function Button({
  variant = "primary",
  className,
  type = "button",
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: keyof typeof VARIANT;
}) {
  return (
    <button
      type={type}
      className={[VARIANT[variant], className].filter(Boolean).join(" ")}
      {...rest}
    />
  );
}
